export const ApiLetterheadFonts = (axios, obuBaseUrl) => {
  axios.setBaseURL(obuBaseUrl)

  const load = async () => {
    const result = await axios.get('/api/settings/letterhead-fonts')
    return result.data
  }

  const save = async (id, payload) => {
    const result = await axios.post(`/api/settings/letterheads-fonts/${id}`, payload)
    return result.data
  }

  return {
    letterheadFontsLoad: load,
    letterheadFontsSave: save
  }
}
